var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-bottom-sheet",
    {
      attrs: {
        value: _vm.dialog,
        "content-class": "half-round",
        persistent: "",
        absolute: "",
        "hide-overlay": "",
        "retain-focus": false,
        attach: "#shoppingCart",
        transition: "",
      },
    },
    [
      _c(
        "v-card",
        {
          class: [
            "half-round",
            _vm.$vuetify.breakpoint.mdAndUp ? "pb-3" : null,
            {
              "pb-16":
                (!_vm.$page.props.profileComplete &&
                  !_vm.$page.props.profileRequired) ||
                _vm.$page.props.impersonating?.impersonatingUser,
            },
          ],
        },
        [
          _c("v-card-title", { staticClass: "soli-grey" }, [
            _vm._v("Checkout"),
          ]),
          _vm._v(" "),
          _c("v-card-subtitle", { staticClass: "pb-0" }, [
            _vm._v(_vm._s(_vm.$page.props.auth.user.selected_location.name)),
          ]),
          _vm._v(" "),
          _vm.checkoutLoading
            ? _c(
                "v-container",
                { staticClass: "flex justify-center align-center" },
                [
                  _c("v-progress-circular", {
                    attrs: { color: "primary", indeterminate: "", size: "54" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.checkoutLoading
            ? _c(
                "v-container",
                { staticClass: "pt-0 px-5" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "px-1 mb-3",
                      model: {
                        value: _vm.tabs,
                        callback: function ($$v) {
                          _vm.tabs = $$v
                        },
                        expression: "tabs",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        {
                          attrs: { disabled: !_vm.client.defaultMethod },
                          on: {
                            click: function ($event) {
                              ;[
                                _vm.clearPaymentMethods(),
                                (_vm.selectPaymentMethod.default.value = true),
                              ]
                            },
                          },
                        },
                        [_vm._v("Default")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.clearPaymentMethods()
                            },
                          },
                        },
                        [_vm._v("New Card")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.clearPaymentMethods()
                            },
                          },
                        },
                        [_vm._v("Promo")]
                      ),
                      _vm._v(" "),
                      _vm.can("Create invoices")
                        ? _c(
                            "v-tab",
                            {
                              on: {
                                click: function ($event) {
                                  ;[
                                    _vm.clearPaymentMethods(),
                                    (_vm.selectPaymentMethod.invoice.value = true),
                                  ]
                                },
                              },
                            },
                            [_vm._v("Invoice")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tabs,
                        callback: function ($$v) {
                          _vm.tabs = $$v
                        },
                        expression: "tabs",
                      },
                    },
                    [
                      _c("v-tab-item", [
                        _c(
                          "div",
                          { class: ["pa-3 ma-0 soli-round"] },
                          [
                            _vm.client.defaultMethod
                              ? _c(
                                  "v-row",
                                  { staticClass: "align-center pa-3" },
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "col-1 px-0" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "rgba(0,0,0,.54)" },
                                          },
                                          [_vm._v("credit_card")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { staticClass: "pl-0 py-0" },
                                      [
                                        _c("v-list", { staticClass: "mx-2" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "caption soli-grey",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.client.defaultMethod
                                                      .billing_details?.name
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: [
                                                "soli-grey",
                                                _vm.$vuetify.breakpoint.xsOnly
                                                  ? "body-2"
                                                  : "body-1",
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.client.defaultMethod
                                                      .card.brand
                                                  ) +
                                                  "\n                                        ****\n                                        " +
                                                  _vm._s(
                                                    _vm.client.defaultMethod
                                                      .card.last4
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "caption soli-grey",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        Expires\n                                        " +
                                                  _vm._s(
                                                    _vm.client.defaultMethod
                                                      .card.exp_month
                                                  ) +
                                                  "/" +
                                                  _vm._s(
                                                    _vm.client.defaultMethod.card.exp_year
                                                      .toString()
                                                      .slice(-2)
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-container",
                            [
                              _vm.cardCapture
                                ? _c("div", [
                                    _c("div", { staticClass: "soli-grey" }, [
                                      _vm._v(
                                        "\n                                Please use card reader to complete this\n                                transaction.\n                            "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.selectPaymentMethod.manualCard
                                          .value,
                                      expression:
                                        "selectPaymentMethod.manualCard.value",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "form",
                                    { attrs: { id: "payment-form" } },
                                    [
                                      _c("div", {
                                        attrs: { id: "payment-element" },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        attrs: { id: "error-message" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.total == 0 ||
                              (!_vm.cardCapture &&
                                !_vm.selectPaymentMethod.manualCard.value)
                                ? _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "flex justify-center" },
                                      [
                                        _c(
                                          "v-btn-toggle",
                                          {
                                            model: {
                                              value: _vm.selectCardOption,
                                              callback: function ($$v) {
                                                _vm.selectCardOption = $$v
                                              },
                                              expression: "selectCardOption",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "soli-blue-text soli-round",
                                                    staticStyle: {
                                                      "min-height": "64px",
                                                    },
                                                    attrs: {
                                                      outlined: "",
                                                      loading:
                                                        _vm.terminalLoading,
                                                      large:
                                                        _vm.$vuetify.breakpoint
                                                          .smAndUp,
                                                      disabled: _vm.total == 0,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.connectReaderHandler()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Card Reader")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "soli-blue-text soli-round",
                                                    staticStyle: {
                                                      "min-height": "64px",
                                                    },
                                                    attrs: {
                                                      loading:
                                                        _vm.elementsLoading,
                                                      outlined: "",
                                                      large:
                                                        _vm.$vuetify.breakpoint
                                                          .smAndUp,
                                                      disabled: _vm.total == 0,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.manualCardElement()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Manual Entry")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectCardOption !== null
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0",
                                          staticStyle: { height: "64px" },
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              label: "Save as default",
                                              disabled: !_vm.defaultMethod,
                                            },
                                            model: {
                                              value: _vm.saveAsDefault,
                                              callback: function ($$v) {
                                                _vm.saveAsDefault = $$v
                                              },
                                              expression: "saveAsDefault",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-tab-item", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex gap-2 justify-between items-start py-4",
                          },
                          [
                            _c(
                              "v-form",
                              {
                                ref: "promo",
                                staticClass: "flex-1",
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.applyPromo.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("v-combobox", {
                                  ref: "promoInput",
                                  attrs: {
                                    outlined: "",
                                    "prepend-inner-icon": "redeem",
                                    dense: "",
                                    disabled: _vm.activePromos.length > 0,
                                    "append-icon": "",
                                    "error-messages": _vm.errors.promo,
                                    rules: _vm.promoRules,
                                    label: "Gift or promo code",
                                    "hide-details": "auto",
                                  },
                                  on: { change: _vm.applyPromo },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({
                                          attrs,
                                          item,
                                          select,
                                          selected,
                                        }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._b(
                                                {
                                                  staticStyle: {
                                                    "pointer-events": "all",
                                                  },
                                                  attrs: {
                                                    small: "",
                                                    "input-value": selected,
                                                    close: "",
                                                  },
                                                  on: {
                                                    change: select,
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      _vm.promoCode = null
                                                      _vm.promoRules = []
                                                      _vm.$emit("clearPromo")
                                                    },
                                                  },
                                                },
                                                "v-chip",
                                                attrs,
                                                false
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1569138582
                                  ),
                                  model: {
                                    value: _vm.promoCode,
                                    callback: function ($$v) {
                                      _vm.promoCode = $$v
                                    },
                                    expression: "promoCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "SoliBtn",
                              {
                                class: { "mb-6": _vm.errors.promo },
                                attrs: {
                                  color: "dark",
                                  loading: _vm.promoLoading,
                                  disabled: _vm.activePromos.length > 0,
                                },
                                on: { click: _vm.applyPromo },
                              },
                              [_vm._v("Apply")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-card-title", { staticClass: "soli-grey" }, [
                                _vm._v("STOP"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-card-subtitle",
                                { staticClass: "soli-grey" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "soli-grey ml-3",
                                      staticStyle: { "text-indent": "-7px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                · This is not recommended.\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "soli-grey ml-3",
                                      staticStyle: { "text-indent": "-7px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                · This will invoice the client for this\n                                transaction and for any charges generated by\n                                memberships.\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "soli-grey ml-3",
                                      staticStyle: { "text-indent": "-7px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                · If an invoice is paid by check, you will\n                                be responsible for marking the invoice as\n                                paid.\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "soli-grey ml-3",
                                      staticStyle: { "text-indent": "-7px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                · If this customer already has an active\n                                membership, any memberships sold at this\n                                location\n                                "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          "will continue billing the original\n                                    payment method"
                                        ),
                                      ]),
                                      _vm._v(".\n                            "),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "soli-grey ml-3",
                                      staticStyle: { "text-indent": "-7px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                · Invoices will be sent to\n                                " +
                                          _vm._s(_vm.client.email) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-container",
            [
              _c("SoliBtn", {
                attrs: {
                  text: `${
                    _vm.selectPaymentMethod[_vm.currentState].text
                  } ${_vm.formatUnitAmount(_vm.total)}`,
                  gradient: "gradient-orange",
                  loading: _vm.loading,
                  disabled:
                    _vm.total > 0 &&
                    (_vm.currentState == "none" ||
                      _vm.terminalLoading ||
                      _vm.cardCapture),
                  block: "",
                },
                on: { click: _vm.selectPaymentMethod[_vm.currentState].method },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.readerError
        ? _c("SoliChoice", {
            attrs: {
              title: _vm.readerError.title,
              subtitle: _vm.readerError.subtitle,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.readerError = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }